// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes remove-hidden {
  0% {
    overflow: hidden;
  }
  100% {
    overflow: inherit;
  }
}
@keyframes bounce2 {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-30px);
  }
  60% {
    transform: translateY(-15px);
  }
}
@keyframes bounce-in-avatar {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
  70% {
    transform: translateY(20px);
  }
  100% {
    transform: scale(1) translate(0);
  }
}
@keyframes avatarBubbleAnim {
  0% {
    opacity: 0;
    transform: translateY(10px); /* Move the elements 100% down */
  }
  80% {
    opacity: 1;
    transform: translateY(-10px); /* Move the elements to their original position */
  }
  100% {
    opacity: 1;
    transform: translate(0); /* Move the elements to their original position */
  }
}
@keyframes slide-up {
  0% {
    opacity: 0;
    transform: translateY(100%); /* Move the elements 100% down */
  }
  100% {
    opacity: 1;
    transform: translate(0); /* Move the elements to their original position */
  }
}
@keyframes quick {
  0% {
    opacity: 0;
    transform: scale(0);
    overflow: hidden;
  }
  90%, 50% {
    overflow: hidden;
  }
  100% {
    opacity: 1;
    transform: scale(1);
    overflow: inherit;
  }
}
@keyframes bounce-in {
  0% {
    opacity: 0;
    overflow: hidden;
  }
  40% {
    opacity: 1;
    overflow: hidden;
  }
  60% {
    transform: translate(-10px);
  }
  80% {
    transform: translate(-15px);
  }
  100% {
    transform: none;
    overflow: inherit;
  }
}
@keyframes bubbleAnim {
  0% {
    opacity: 0;
    transform: translateY(10%);
  }
  20% {
    opacity: 0;
    transform: translateY(10%);
  }
  100% {
    opacity: 1;
    transform: translate(0%);
  }
}
@keyframes voiceShowAnim {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  100% {
    opacity: 1;
    transform: translate(0%);
  }
}
@keyframes left-to-right-slide-anim {
  0% {
    opacity: 0;
    transform: translateX(-100%);
  }
  80% {
    opacity: 0.5;
    transform: translateX(0px);
  }
  100% {
    opacity: 1;
    transform: translate(0);
  }
}
@keyframes right-to-left-slide-anim {
  0% {
    opacity: 0;
    transform: translateX(100%); /* Move the elements 100% down */
  }
  80% {
    opacity: 0.5;
    transform: translateX(10px); /* Move the elements to their original position */
  }
  100% {
    opacity: 1;
    transform: translate(0); /* Move the elements to their original position */
  }
}
@keyframes recording {
  from {
    transform: scale(1.1);
    box-shadow: 0 0 0 0 rgba(75, 78, 222, 0.2), 0 0 0 1px rgba(75, 78, 222, 0.2), 0 0 0 3px rgba(75, 78, 222, 0.2), 0 0 0 5px rgba(75, 78, 222, 0.2);
  }
  50% {
    transform: none;
  }
  to {
    transform: scale(1.1);
    box-shadow: 0 0 0 0 rgba(75, 78, 222, 0.2), 0 0 0 3px rgba(75, 78, 222, 0.2), 0 0 0 6px rgba(75, 78, 222, 0), 0 0 0 10px rgba(75, 78, 222, 0);
  }
}
@keyframes voiceAnim {
  from {
    transform: scale(1.1);
  }
  0% {
    box-shadow: 0 0 0 0 rgba(75, 78, 222, 0.2), 0 0 0 1px rgba(75, 78, 222, 0.2), 0 0 0 3px rgba(75, 78, 222, 0.2), 0 0 0 5px rgba(75, 78, 222, 0.2);
  }
  50% {
    transform: none;
  }
  100% {
    box-shadow: 0 0 0 0 rgba(75, 78, 222, 0.2), 0 0 0 4px rgba(75, 78, 222, 0.2), 0 0 0 20px rgba(75, 78, 222, 0), 0 0 0 30px rgba(75, 78, 222, 0);
    transform: scale(1.1);
  }
  to {
    transform: scale(1.1);
  }
}
@keyframes closeBottomToTopAnim {
  0% {
    transform: translateY(0%);
  }
  100% {
    opacity: 0;
    transform: translateY(100%);
    display: none;
  }
}
@keyframes slideBottomToTopAnim {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  80% {
    opacity: 1;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translate(0);
  }
}
.zoomIn {
  -webkit-animation-name: zoomIn;
  animation-name: zoomIn;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes zoomIn {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
@keyframes zoomIn {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
.slideInRight {
  -webkit-animation-name: slideInRight;
  animation-name: slideInRight;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes slideInRight {
  0% {
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    visibility: visible;
  }
  80% {
    -webkit-transform: translateX(0);
    transform: translateX(2px);
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}
@keyframes slideInRight {
  0% {
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    visibility: visible;
  }
  80% {
    -webkit-transform: translateX(0);
    transform: translateX(2px);
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}
.scale-up-br {
  -webkit-animation: scale-up-br 0.4s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  animation: scale-up-br 0.4s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.scale-out-br {
  -webkit-animation: scale-out-br 0.5s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
  animation: scale-out-br 0.5s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
}

@-webkit-keyframes scale-out-br {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
    opacity: 1;
  }
}
@keyframes scale-out-br {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
    opacity: 1;
  }
}
@-webkit-keyframes scale-up-br {
  0% {
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
  }
}
@keyframes scale-up-br {
  0% {
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
  }
}
@-webkit-keyframes spinLoader {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes spinLoader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.rotateIn {
  -webkit-animation-name: rotateIn;
  animation-name: rotateIn;
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes rotateIn {
  0% {
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transform: rotate3d(0, 0, 1, -200deg);
    transform: rotate3d(0, 0, 1, -200deg);
    opacity: 0;
  }
  100% {
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transform: none;
    transform: none;
    opacity: 1;
  }
}
@keyframes rotateIn {
  0% {
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transform: rotate3d(0, 0, 1, -200deg);
    transform: rotate3d(0, 0, 1, -200deg);
    opacity: 0;
  }
  100% {
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transform: none;
    transform: none;
    opacity: 1;
  }
}
@keyframes dot-flashing {
  0% {
    background-color: var(--sdk-gloabl-bg-secondary);
  }
  50%, 100% {
    opacity: 0.5;
  }
}
.fadeIn {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  display: flex;
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.bounceInUp {
  -webkit-animation-name: bounceInUp;
  animation-name: bounceInUp;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes bounceInUp {
  0%, 60%, 75%, 90%, 100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 3000px, 0);
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
  }
  75% {
    -webkit-transform: translate3d(0, 10px, 0);
    transform: translate3d(0, 10px, 0);
  }
  90% {
    -webkit-transform: translate3d(0, -5px, 0);
    transform: translate3d(0, -5px, 0);
  }
  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
@keyframes bounceInUp {
  0%, 60%, 75%, 90%, 100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 3000px, 0);
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
  }
  75% {
    -webkit-transform: translate3d(0, 10px, 0);
    transform: translate3d(0, 10px, 0);
  }
  90% {
    -webkit-transform: translate3d(0, -5px, 0);
    transform: translate3d(0, -5px, 0);
  }
  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
.fadeInUp {
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInUp {
  0% {
    opacity: 1;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
.fadeOut {
  -webkit-animation-name: fadeOut;
  animation-name: fadeOut;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.slideOutDown {
  -webkit-animation-name: slideOutDown;
  animation-name: slideOutDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes slideOutDown {
  0% {
    -webkit-transform: translateY(-10%);
    transform: translateY(-10%);
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
:root {
  --sdk-gloabl-primary-color:var(--chat-sdk-branding--global-primary-color);
  --sdk-gloabl-secondary-color:var(--chat-sdk-branding--global-secondary-color);
  --sdk-global-primary-text:var(--chat-sdk-branding--global-primary-text);
  --sdk-global-secondary-text:var(--chat-sdk-branding--global-secondary-text);
  --theme-panel-wigdet-primary-bg-color:var(--sdk-gloabl-primary-color);
  --theme-panel-wigdet-secondary-bg-color:var(--sdk-gloabl-secondary-color);
  --theme-panel-wigdet-primary-text-color:var(--sdk-global-primary-text);
  --theme-panel-wigdet-secondary-text-color:var(--sdk-global-secondary-text) ;
  --panel-wigdet-primary-bg-color:var(--theme-panel-wigdet-primary-bg-color);
  --panel-wigdet-secondary-bg-color:var(--theme-panel-wigdet-secondary-bg-color);
  --panel-wigdet-primary-text-color:var(--theme-panel-wigdet-primary-text-color);
  --panel-wigdet-secondary-text-color:var(--theme-panel-wigdet-secondary-text-color);
  --panel-wigdet-border-color:var(--panel-wigdet-secondary-bg-color);
  --panel-wigdet-white-bg-color:var(--chat-sdk-branding--widget_panel-colors-bg_color);
  --panel-wigdet-white-text-color:#fff;
  --panel-wigdet-left-menu-bg:var(--chat-sdk-branding--widget_panel-colors-bg_color);
  --panel-wigdet-left-menu-selected-bg:var(--chat-sdk-branding--widget_panel-colors-sel_bg_color);
  --panel-wigdet-left-menu-font-clr:var(--chat-sdk-branding--widget_panel-colors-color);
  --panel-wigdet-left-menu-selected-font-clr:var(--chat-sdk-branding--widget_panel-colors-sel_color);
  --global-font-family: var(--chat-sdk-branding--global-font-family);
  --sdk-global-theme-color:var(--sdk-gloabl-primary-color);
  --sdk-gloabl-bg-secondary:var(--sdk-gloabl-secondary-color);
  --sdk-global-white:var(--sdk-global-secondary-text);
  --sdk-global-white-bg:var(--chat-sdk-branding--body-white-background);
  --sdk-gloabl-text-color:var(--sdk-global-primary-text);
  --sdk-gloabl-text-desc-color:var(--sdk-global-primary-text);
  --sdk-gloabl-border-color:var(--sdk-gloabl-secondary-color);
  --sdk-scrollbar-bg:var(--sdk-gloabl-bg-secondary);
  --avatar-bg:var(--chat-sdk-branding--chat_bubble-bg-primary_color);
  --avatar-send-msg-bg:var(--chat-sdk-branding--chat_bubble-bg-primary_color);
  --avatar-icon-color:var(--chat-sdk-branding--chat_bubble-bg-secondary_color);
  --avatar-text-colr:var(--sdk-gloabl-text-color);
  --chat-widget-box-shadow:0px 4px 12px 2px rgba(32, 33, 36, 0.12);
  --agent-joined-bg:var(--sdk-gloabl-bg-secondary);
  --agent-joined-border:var(--sdk-gloabl-border-color);
  --agent-joined-text-color:var(--sdk-gloabl-text-color);
  --welcome-bg:var(--sdk-global-white-bg);
  --welcome-shadow:0px 4px 12px 2px rgba(32,33,36,0.12);
  --welcome-header-bg: var(--chat-sdk-branding--welcome_screen-background-color);
  --welcome-header-text-color:var(--chat-sdk-branding--welcome_screen-top_fonts-color);
  --welcome-start-conv-bg:var(--sdk-global-white-bg);
  --welcome-start-conv-border:var(--sdk-gloabl-border-color);
  --welcome-start-conv-bot-bg:var(--sdk-global-theme-color);
  --welcome-start-conv-bot-title:var(--sdk-gloabl-text-color);
  --welcome-start-conv-bot-desc:var(--sdk-gloabl-text-desc-color);
  --welcome-start-conv-quick-btn-bg:var(--sdk-global-white-bg);
  --welcome-start-conv-quick-btn-border:var(--sdk-gloabl-border-color);
  --welcome-start-conv-quick-btn-text:var(--sdk-gloabl-text-color);
  --welcome-start-conv-search-bg:var(--sdk-global-white-bg);
  --welcome-start-conv-search-border:var(--sdk-gloabl-border-color);
  --welcome-start-conv-button-bg:var(--chat-sdk-branding--welcome_screen-starter_box-start_conv_button_color);
  --welcome-start-conv-button-border:var(--sdk-global-theme-color);
  --welcome-start-conv-button-color:var(--chat-sdk-branding--welcome_screen-starter_box-start_conv_text_color);
  --welcome-footer-bg:var(--chat-sdk-branding--welcome_screen-bottom_background-color);
  --welecome-footer-text-color:var(--sdk-gloabl-text-color);
  --chat-widget-header-bg:var(--chat-sdk-branding--header-bg-bg_color);
  --chat-widget-header-border:var(--sdk-gloabl-border-color);
  --chat-widget-header-bg-large:linear-gradient(180deg, var(--sdk-global-theme-color) 0%, var(--sdk-global-theme-color) 40.67%, rgba(255, 255, 255, 0) 80.38%);
  --chat-widget-header-bg-large-info-bg:var(--sdk-global-white-bg);
  --chat-widget-header-bg-large-actions-color:var(--sdk-global-white);
  --chat-widget-header-bot-name-color:var(--chat-sdk-branding--header-title-color);
  --chat-widget-header-bot-name-desc:var(--chat-sdk-branding--header-sub_title-color);
  --chat-widget-header-actions-color:var(--chat-sdk-branding--header-icons-color);
  --chat-widget-header-img-border:var(--sdk-global-white);
  --chat-widget-body-bg:var(--chat-sdk-branding--body-background-bg);
  --chat-widget-footer-bg: var(--sdk-global-white-bg);
  --chat-widget-compose-bar-bg:var(--chat-sdk-branding--footer-bg-bg_color);
  --chat-widget-compose-bar-border:var(--sdk-gloabl-border-color);
  --chat-widget-compose-bar-text-area-bg:var(--chat-sdk-branding--footer-compose_bar-bg_color);
  --chat-widget-compose-bar-text-area-border:var(--chat-sdk-branding--footer-compose_bar-outline-color);
  --chat-widget-compose-bar-text-area-color:var(--sdk-gloabl-text-color);
  --chat-widget-compose-bar-text-area-placeholder-color:var(--sdk-gloabl-text-color);
  --chat-widget-compose-bar-voice-speak-info-text:var(--sdk-gloabl-text-color);
  --chat-widget-compose-bar-voice-icon-bg:var(--sdk-global-theme-color);
  --chat-widget-compose-bar-voice-icon-border:var(--sdk-global-white-bg);
  --chat-widget-compose-bar-voice-icon-color:var(--sdk-global-white);
  --chat-widget-compose-bar-voice-speak-msg-bg:var(--sdk-global-white-bg);
  --chat-widget-compose-bar-voice-speak-msg-selected-bg:var(--sdk-gloabl-bg-secondary);
  --chat-widget-compose-bar-voice-speak-msg-color:var(--sdk-global-theme-color);
  --chat-widget-compose-bar-voice-speak-msg-border:var(--sdk-global-theme-color);
  --chat-widget-compose-bar-voice-recording-animation-shadow:0 0 0 0 rgba(var(--sdk-global-theme-color), 0.2), 0 0 0 1px rgba(var(--sdk-global-theme-color), 0.2), 0 0 0 3px rgba(var(--sdk-global-theme-color), 0.2), 0 0 0 5px rgba(var(--sdk-global-theme-color), 0.2);
  --chat-widget-compose-bar-voice-recording-animation-shadow-zoom:0 0 0 0 rgba(var(--sdk-global-theme-color), 0.2),0 0 0 3px rgba(var(--sdk-global-theme-color), 0.2),0 0 0 6px rgba(var(--sdk-global-theme-color), 0),0 0 0 10px rgba(var(--sdk-global-theme-color), 0);
  --chat-widget-compose-bar-menu-icon-color:var(--chat-sdk-branding--footer-menu_icon-color);
  --chat-widget-compose-bar-other-icons:var(--chat-sdk-branding--footer-icons-color);
  --bot-bubble-text-color:var(--sdk-gloabl-text-color);
  --bot-bubble-msg-bg:var(--chat-sdk-branding--body-bot_message-bg_color);
  --bot-bubble-msg-bg-hover:var(--chat-sdk-branding--body-bot_message-bg_color);
  --bot-bubble-msg-color:var(--chat-sdk-branding--body-bot_message-color);
  --bot-bubble-img-border:var(--sdk-global-white-bg);
  --name-color:var(--chat-sdk-branding--body-agent_message-title_color);
  --time-stamp-color:var(--chat-sdk-branding--body-time_stamp-color);
  --agent-bubble-text-color:var(--sdk-gloabl-text-color);
  --agent-bubble-msg-bg:var(--chat-sdk-branding--body-user_message-bg_color);
  --agent-bubble-msg-bg-hover:var(--chat-sdk-branding--body-user_message-bg_color);
  --agent-bubble-msg-color:var(--chat-sdk-branding--body-user_message-color);
  --agent-bubble-img-border:var(--sdk-global-white-bg);
  --agent-bubble-read-status-icon-color:#22C55E;
  --date-seperator-bg:var(--sdk-gloabl-bg-secondary);
  --date-seperator-border:var(--sdk-gloabl-border-color);
  --date-seperator-line-border:var(--sdk-gloabl-border-color);
  --date-seperator-color:var(--sdk-gloabl-text-color);
  --button-bg-color: var(--chat-sdk-branding--body-buttons-bg_color);
  --button-text-color: var(--chat-sdk-branding--body-buttons-color);
  --button-temp-bg:var(--sdk-global-white-bg);
  --button-temp-border:var(--sdk-gloabl-border-color);
  --button-temp-color:var(--sdk-gloabl-text-color);
  --button-temp-bg-hover:var(--sdk-gloabl-bg-secondary);
  --button-temp-bg-variation-1:var(--sdk-gloabl-bg-secondary);
  --button-temp-variation-1-border:transparent;
  --button-temp-variation-1-color:var(--button-bg-color);
  --button-temp-bg-variation-1-hover:linear-gradient(0deg, rgba(75, 78, 222, 0.07) 0%, rgba(75, 78, 222, 0.07) 100%), var(--sdk-gloabl-bg-secondary);
  --button-temp-bg-variation-2:var(--button-bg-color);
  --button-temp-variation-2-border:var(--button-bg-color);
  --button-temp-variation-2-color:var(--button-text-color);
  --button-temp-bg-variation-2-hover:linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), var(--button-bg-color);
  --card-main-wrapper-bg:var(--sdk-gloabl-bg-secondary);
  --card-main-wrapper-border:var(--sdk-gloabl-border-color);
  --card-heading-title:var(--sdk-gloabl-text-color);
  --card-temp-border:var(--sdk-gloabl-border-color);
  --card-temp-bg:var(--sdk-global-white-bg);
  --card-temp-color:var(--sdk-gloabl-text-color);
  --card-temp-h1-color:var(--sdk-gloabl-text-color);
  --card-temp-p-color:var(--sdk-gloabl-text-color);
  --card-temp-view-more-bg:var(--sdk-global-white-bg);
  --card-temp-view-more-color:var(--sdk-global-theme-color);
  --card-temp-view-more-border:var(--sdk-global-theme-color);
  --card-temp-border-divided-bg:var(--sdk-gloabl-border-color);
  --form-temp-bg:var(--sdk-gloabl-bg-secondary);
  --form-temp--text-color:var(--sdk-gloabl-text-color);
  --form-temp-input-bg:var(--sdk-global-white-bg);
  --form-temp-input-box-shadow:0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  --form-temp-input-placeholder:var(--sdk-gloabl-text-color);
  --table-border:var(--sdk-gloabl-border-color);
  --table-header-text-color:var(--sdk-gloabl-text-color);
  --table-body-tr-bg:var(--sdk-gloabl-bg-secondary);
  --table-desc-text-color:var(--sdk-gloabl-text-color);
  --radio-desc-text-clr:var(--sdk-gloabl-text-color);
  --radio-border:var(--sdk-gloabl-border-color);
  --radio-bg:var(--sdk-global-white-bg);
  --radio-checked-shadow:inset 0 0 0 6px var(--sdk-global-white-bg);
}

.kr-button-primary {
  border-radius: 4px;
  padding: 5px 16px;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  height: 30px;
  width: 100%;
  cursor: pointer;
  text-align: center;
  transition: 0.2s all ease;
  background: var(--button-temp-bg-variation-2);
  border: 1px solid var(--button-temp-variation-2-border);
  color: var(--button-temp-variation-2-color);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
}
.kr-button-primary.lg {
  padding: 10px 16px;
  height: 40px;
  font-size: 14px;
}
.kr-button-primary:hover {
  background: var(--button-temp-bg-variation-2-hover);
}
.kr-button-primary:disabled {
  opacity: 0.5;
  pointer-events: none;
}

.kr-button-secondary {
  width: 100%;
  background: var(--button-temp-bg);
  border: 1px solid var(--button-temp-border);
  border-radius: 4px;
  padding: 5px 16px;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  height: 30px;
  color: var(--button-temp-color);
  cursor: pointer;
  text-align: center;
  transition: 0.2s all ease;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
}
.kr-button-secondary.lg {
  padding: 10px 16px;
  height: 40px;
  font-size: 14px;
}
.kr-button-secondary:hover {
  background: var(--button-temp-bg-hover);
}

.kr-button-blue-light {
  width: 100%;
  background: var(--button-bg-color);
  border: 1px solid var(--button-bg-color);
  border-radius: 4px;
  padding: 5px 16px;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  height: 30px;
  color: var(--button-text-color);
  cursor: pointer;
  text-align: center;
  transition: 0.2s all ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
}
.kr-button-blue-light svg path {
  fill: var(--button-bg-color);
}
.kr-button-blue-light.lg {
  padding: 10px 16px;
  height: 40px;
  font-size: 14px;
}
.kr-button-blue-light:hover {
  background: var(--button-bg-color);
}

.kore-chat-window-main-section .chart-disp-val {
  fill: var(--sdk-gloabl-text-color);
  font-size: 12px;
}
.kore-chat-window-main-section .chart-axis-line {
  stroke: var(--sdk-gloabl-text-color);
}
.kore-chat-window-main-section .legend-title {
  fill: var(--sdk-gloabl-text-color);
  font-size: 12px;
}
.kore-chat-window-main-section polyline {
  stroke: var(--sdk-gloabl-text-color);
}
.kore-chat-window-main-section .mouse-per-line text {
  fill: var(--sdk-gloabl-text-color);
  font-size: 12px;
}
.kore-chat-window-main-section .legend-value {
  fill: var(--sdk-gloabl-text-color);
  font-size: 12px;
}

.chat-widget-body-wrapper {
  flex: 1 1 auto;
  background: var(--chat-widget-body-bg) no-repeat;
  background-size: cover;
  overflow: auto;
  height: calc(100vh - 330px);
  padding-bottom: 5px;
}
.chat-widget-body-wrapper .prev-message-list {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/base/animations.scss","webpack://./src/templatemanager/base/chatWidgetBody/chatWidgetBody.scss","webpack://./src/templatemanager/base/variables.scss"],"names":[],"mappings":"AAEA;EACI;IACE,gBAAA;ECDJ;EDGE;IACI,iBAAA;ECDN;AACF;ADIA;EACI;IAAyB,wBAAA;ECD3B;EDEE;IAAK,4BAAA;ECCP;EDAE;IAAK,4BAAA;ECGP;AACF;ADFA;EACI;IACE,UAAA;IACA,qBAAA;ECIJ;EDFE;IACE,UAAA;IACA,mBAAA;ECIJ;EDFE;IAAM,2BAAA;ECKR;EDJE;IAAO,gCAAA;ECOT;AACF;ADLA;EACI;IACE,UAAA;IACA,2BAAA,EAAA,gCAAA;ECOJ;EDLE;IACI,UAAA;IACA,4BAAA,EAAA,iDAAA;ECON;EDLE;IACE,UAAA;IACA,uBAAA,EAAA,iDAAA;ECOJ;AACF;ADJA;EACI;IACI,UAAA;IACA,2BAAA,EAAA,gCAAA;ECMN;EDJE;IACI,UAAA;IACA,uBAAA,EAAA,iDAAA;ECMN;AACF;ADAA;EACI;IACE,UAAA;IACA,mBAAA;IACA,gBAAA;ECEJ;EDAE;IACE,gBAAA;ECEJ;EDAE;IACI,UAAA;IACA,mBAAA;IACA,iBAAA;ECEN;AACF;ADAA;EACI;IACE,UAAA;IACA,gBAAA;ECEJ;EDAE;IACE,UAAA;IACA,gBAAA;ECEJ;EDAE;IACE,2BAAA;ECEJ;EDAE;IACE,2BAAA;ECEJ;EDAE;IACE,eAAA;IACA,iBAAA;ECEJ;AACF;ADKA;EACI;IACE,UAAA;IACA,0BAAA;ECHJ;EDKE;IACE,UAAA;IACA,0BAAA;ECHJ;EDKE;IACE,UAAA;IACA,wBAAA;ECHJ;AACF;ADUA;EACE;IACE,UAAA;IACA,2BAAA;ECRF;EDUA;IACE,UAAA;IACA,wBAAA;ECRF;AACF;ADaA;EACI;IACE,UAAA;IACA,4BAAA;ECXJ;EDaE;IACI,YAAA;IACA,0BAAA;ECXN;EDaE;IACE,UAAA;IACA,uBAAA;ECXJ;AACF;ADkBA;EACI;IACE,UAAA;IACA,2BAAA,EAAA,gCAAA;EChBJ;EDkBE;IACI,YAAA;IACA,2BAAA,EAAA,iDAAA;EChBN;EDkBE;IACE,UAAA;IACA,uBAAA,EAAA,iDAAA;EChBJ;AACF;ADqBA;EACI;IACI,qBAAA;IACA,gJAAA;ECnBN;EDyBE;IACI,eAAA;ECvBN;ED0BE;IACI,qBAAA;IACA,6IAAA;ECxBN;AACF;AD8BA;EACI;IACI,qBAAA;EC5BN;ED8BE;IACI,gJAAA;EC5BN;EDkCI;IACE,eAAA;EChCN;EDkCI;IACE,8IAAA;IAKA,qBAAA;ECpCN;EDsCE;IACI,qBAAA;ECpCN;AACF;AD2CA;EACI;IACE,yBAAA;ECzCJ;ED2CE;IACI,UAAA;IACA,2BAAA;IACA,aAAA;ECzCN;AACF;AD2CA;EACI;IACE,UAAA;IACA,2BAAA;ECzCJ;ED2CE;IACI,UAAA;IACA,4BAAA;ECzCN;ED2CE;IACE,UAAA;IACA,uBAAA;ECzCJ;AACF;ADiDA;EACE,8BAAA;EACA,sBAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;AC/CF;;ADkDA;EACE;IACE,UAAA;IACA,yCAAA;IACA,iCAAA;EC/CF;EDiDA;IACE,UAAA;EC/CF;AACF;ADkDA;EACE;IACE,UAAA;IACA,yCAAA;IACA,iCAAA;EChDF;EDkDA;IACE,UAAA;EChDF;AACF;ADuDA;EACE,oCAAA;EACA,4BAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;ACrDF;;ADwDA;EACE;IACE,mCAAA;IACA,2BAAA;IACA,mBAAA;ECrDF;EDuDA;IACE,gCAAA;IACA,0BAAA;ECrDF;EDuDA;IACE,gCAAA;IACA,wBAAA;ECrDF;AACF;ADwDA;EACE;IACE,mCAAA;IACA,2BAAA;IACA,mBAAA;ECtDF;EDwDA;IACE,gCAAA;IACA,0BAAA;ECtDF;EDwDA;IACE,gCAAA;IACA,wBAAA;ECtDF;AACF;ADyDA;EACC,4EAAA;EACQ,oEAAA;ACvDT;;AD0DA;EACC,+EAAA;EACQ,uEAAA;ACvDT;;AD0DC;EACC;IACE,2BAAA;IACQ,mBAAA;IACR,mCAAA;IACQ,2BAAA;IACR,UAAA;ECvDF;EDyDA;IACE,2BAAA;IACQ,mBAAA;IACR,mCAAA;IACQ,2BAAA;IACR,UAAA;ECvDF;AACF;AD0DA;EACE;IACE,2BAAA;IACQ,mBAAA;IACR,mCAAA;IACQ,2BAAA;IACR,UAAA;ECxDF;ED0DA;IACE,2BAAA;IACQ,mBAAA;IACR,mCAAA;IACQ,2BAAA;IACR,UAAA;ECxDF;AACF;AD4DA;EACA;IACE,6BAAA;IACQ,qBAAA;IACR,mCAAA;IACQ,2BAAA;EC1DR;ED4DF;IACE,2BAAA;IACQ,mBAAA;IACR,mCAAA;IACQ,2BAAA;EC1DR;AACF;AD6DA;EACE;IACE,6BAAA;IACQ,qBAAA;IACR,mCAAA;IACQ,2BAAA;EC3DV;ED6DA;IACE,2BAAA;IACQ,mBAAA;IACR,mCAAA;IACQ,2BAAA;EC3DV;AACF;ADiEA;EACE;IAAK,+BAAA;EC9DL;ED+DA;IAAO,iCAAA;EC5DP;AACF;AD8DA;EACE;IAAK,uBAAA;EC3DL;ED4DA;IAAO,yBAAA;ECzDP;AACF;AD8DA;EACE,gCAAA;EACA,wBAAA;EACA,gCAAA;EACA,wBAAA;EACA,iCAAA;EACA,yBAAA;AC5DF;;AD+DA;EACE;IACE,gCAAA;IACA,wBAAA;IACA,6CAAA;IACA,qCAAA;IACA,UAAA;EC5DF;ED+DA;IACE,gCAAA;IACA,wBAAA;IACA,uBAAA;IACA,eAAA;IACA,UAAA;EC7DF;AACF;ADgEA;EACE;IACE,gCAAA;IACA,wBAAA;IACA,6CAAA;IACA,qCAAA;IACA,UAAA;EC9DF;EDiEA;IACE,gCAAA;IACA,wBAAA;IACA,uBAAA;IACA,eAAA;IACA,UAAA;EC/DF;AACF;ADqEA;EACE;IACI,gDAAA;ECnEJ;EDqEA;IACI,YAAA;ECnEJ;AACF;ADwEA;EACE,8BAAA;EACA,sBAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;EACA,aAAA;ACtEF;;ADyEA;EACE;IACE,UAAA;ECtEF;EDyEA;IACE,UAAA;ECvEF;AACF;AD0EA;EACE;IACE,UAAA;ECxEF;ED2EA;IACE,UAAA;ECzEF;AACF;AD+EA;EACE,kCAAA;EACA,0BAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;AC7EF;;ADgFA;EAEE;IAKE,uEAAA;IACA,+DAAA;EClFF;EDqFA;IACE,UAAA;IACA,4CAAA;IACA,oCAAA;ECnFF;EDsFA;IACE,UAAA;IACA,2CAAA;IACA,mCAAA;ECpFF;EDuFA;IACE,0CAAA;IACA,kCAAA;ECrFF;EDwFA;IACE,0CAAA;IACA,kCAAA;ECtFF;EDyFA;IACE,uCAAA;IACA,+BAAA;ECvFF;AACF;AD0FA;EAEE;IAKE,uEAAA;IACA,+DAAA;EC7FF;EDgGA;IACE,UAAA;IACA,4CAAA;IACA,oCAAA;EC9FF;EDiGA;IACE,UAAA;IACA,2CAAA;IACA,mCAAA;EC/FF;EDkGA;IACE,0CAAA;IACA,kCAAA;EChGF;EDmGA;IACE,0CAAA;IACA,kCAAA;ECjGF;EDoGA;IACE,uCAAA;IACA,+BAAA;EClGF;AACF;ADuGA;EACE,kCAAA;EACA,0BAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;ACrGF;;ADwGA;EACE;IACE,UAAA;IACA,2CAAA;IACA,mCAAA;ECrGF;EDwGA;IACE,UAAA;IACA,uBAAA;IACA,eAAA;ECtGF;AACF;ADyGA;EACE;IACE,UAAA;IACA,2CAAA;IACA,mCAAA;ECvGF;ED0GA;IACE,UAAA;IACA,uBAAA;IACA,eAAA;ECxGF;AACF;AD6GA;EACE,gCAAA;EACA,wBAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;AC3GF;;AD8GA;EACE;IACE,UAAA;IACA,0CAAA;IACA,kCAAA;EC3GF;ED8GA;IACE,UAAA;IACA,uBAAA;IACA,eAAA;EC5GF;AACF;AD+GA;EACE;IACE,UAAA;IACA,0CAAA;IACA,kCAAA;EC7GF;EDgHA;IACE,UAAA;IACA,uBAAA;IACA,eAAA;EC9GF;AACF;ADmHA;EACE,+BAAA;EACA,uBAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;ACjHF;;ADoHA;EACE;IACE,UAAA;ECjHF;EDoHA;IACE,UAAA;EClHF;AACF;ADqHA;EACE;IACE,UAAA;ECnHF;EDsHA;IACE,UAAA;ECpHF;AACF;ADuHA;EACI,oCAAA;EACA,4BAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;ACrHJ;;ADuHE;EACE;IACE,mCAAA;IACA,2BAAA;ECpHJ;EDsHE;IACE,gCAAA;IACA,wBAAA;ECpHJ;AACF;ACrlBA;EAGI,yEAAA;EACA,6EAAA;EACA,uEAAA;EACA,2EAAA;EAII,qEAAA;EACA,yEAAA;EACA,sEAAA;EACA,2EAAA;EAGA,0EAAA;EACA,8EAAA;EACA,8EAAA;EACA,kFAAA;EAEA,kEAAA;EACA,oFAAA;EACA,oCAAA;EACA,kFAAA;EACA,+FAAA;EACA,qFAAA;EACA,kGAAA;EAMA,kEAAA;EAGJ,wDAAA;EACA,2DAAA;EACA,mDAAA;EACA,qEAAA;EACA,sDAAA;EACA,2DAAA;EACA,2DAAA;EACA,iDAAA;EAGI,kEAAA;EACA,2EAAA;EACA,4EAAA;EACA,+CAAA;EAIA,gEAAA;EAIA,gDAAA;EACA,oDAAA;EACA,sDAAA;EAIA,uCAAA;EACA,qDAAA;EACA,8EAAA;EACA,oFAAA;EACA,kDAAA;EACA,0DAAA;EACA,yDAAA;EACA,2DAAA;EACA,+DAAA;EACA,4DAAA;EACA,oEAAA;EACA,gEAAA;EACA,yDAAA;EACA,iEAAA;EACA,2GAAA;EACA,gEAAA;EACA,4GAAA;EACA,oFAAA;EACA,yDAAA;EAIA,oEAAA;EACA,0DAAA;EACA,4JAAA;EACA,gEAAA;EACA,mEAAA;EACA,gFAAA;EACA,mFAAA;EACA,+EAAA;EACA,uDAAA;EAIA,kEAAA;EAIA,mDAAA;EACA,yEAAA;EACA,+DAAA;EACA,4FAAA;EACA,qGAAA;EACA,sEAAA;EACA,kFAAA;EACA,4EAAA;EACA,qEAAA;EACA,sEAAA;EACA,kEAAA;EACA,uEAAA;EACA,oFAAA;EACA,6EAAA;EACA,8EAAA;EACA,uQAAA;EACA,sQAAA;EACA,0FAAA;EACA,kFAAA;EAIA,oDAAA;EACA,uEAAA;EACA,6EAAA;EACA,uEAAA;EACA,kDAAA;EAIA,qEAAA;EAIA,kEAAA;EAIA,sDAAA;EACA,0EAAA;EACA,gFAAA;EACA,0EAAA;EACA,oDAAA;EACA,6CAAA;EAIA,kDAAA;EACA,sDAAA;EACA,2DAAA;EACA,mDAAA;EAIA,kEAAA;EACA,iEAAA;EAMA,2CAAA;EACA,mDAAA;EACA,gDAAA;EACA,qDAAA;EACA,2DAAA;EACA,4CAAA;EACA,sDAAA;EACA,kJAAA;EACA,mDAAA;EACA,uDAAA;EACA,wDAAA;EACA,kIAAA;EAIA,qDAAA;EACA,yDAAA;EACA,iDAAA;EACA,iDAAA;EACA,yCAAA;EACA,8CAAA;EACA,iDAAA;EACA,gDAAA;EACA,mDAAA;EACA,yDAAA;EACA,0DAAA;EACA,4DAAA;EAIA,6CAAA;EACA,oDAAA;EACA,+CAAA;EACA,mEAAA;EACA,0DAAA;EAGA,6CAAA;EACA,sDAAA;EACA,iDAAA;EACA,oDAAA;EAII,kDAAA;EACA,6CAAA;EACA,qCAAA;EACA,iEAAA;ADkhBZ;;AC1eA;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,6CAAA;EACA,uDAAA;EACA,2CAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AD6eJ;AC5eI;EACI,kBAAA;EACA,YAAA;EACA,eAAA;AD8eR;AC5eI;EACI,mDAAA;AD8eR;AC5eI;EACI,YAAA;EACA,oBAAA;AD8eR;;AC3eA;EACI,WAAA;EACA,iCAAA;EACA,2CAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AD8eJ;AC7eI;EACI,kBAAA;EACA,YAAA;EACA,eAAA;AD+eR;AC7eI;EACI,uCAAA;AD+eR;;AC3eA;EACI,WAAA;EACA,kCAAA;EACA,wCAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AD8eJ;AC5eQ;EACI,4BAAA;AD8eZ;AC3eI;EACI,kBAAA;EACA,YAAA;EACA,eAAA;AD6eR;AC3eI;EACI,kCAAA;AD6eR;;ACxeI;EACI,kCAAA;EACA,eAAA;AD2eR;ACzeI;EACI,oCAAA;AD2eR;ACzeI;EACI,kCAAA;EACA,eAAA;AD2eR;ACzeI;EACI,oCAAA;AD2eR;ACxeQ;EACI,kCAAA;EACA,eAAA;AD0eZ;ACveI;EACI,kCAAA;EACA,eAAA;ADyeR;;AA/1BA;EACI,cAAA;EACA,gDAAA;EACA,sBAAA;EACA,cAAA;EACA,2BAAA;EACA,mBAAA;AAk2BJ;AAj2BI;EACI,aAAA;AAm2BR","sourcesContent":["// Avatar animations\n\n@keyframes remove-hidden {\n    0% {\n      overflow: hidden;\n    }\n    100% { \n        overflow: inherit; \n    }\n}\n\n@keyframes bounce2 {\n    0%, 20%, 50%, 80%, 100% {transform: translateY(0);}\n    40% {transform: translateY(-30px);}\n    60% {transform: translateY(-15px);}\n}\n@keyframes bounce-in-avatar {\n    0% {\n      opacity: 0;\n      transform: scale(.3);\n    }\n    50% {\n      opacity: 1;\n      transform: scale(1);\n    }\n    70% { transform:translateY(20px)}\n    100% { transform: scale(1) translate(0);}\n}\n\n@keyframes avatarBubbleAnim {\n    0% {\n      opacity: 0;\n      transform: translateY(10px); /* Move the elements 100% down */\n    }\n    80% {\n        opacity: 1;\n        transform: translateY(-10px); /* Move the elements to their original position */\n    }\n    100% {\n      opacity: 1;\n      transform: translate(0); /* Move the elements to their original position */\n    }\n}\n\n@keyframes slide-up {\n    0% {\n        opacity: 0;\n        transform: translateY(100%); /* Move the elements 100% down */\n    }\n    100% {\n        opacity: 1;\n        transform: translate(0); /* Move the elements to their original position */\n    }\n}\n\n// End Avatar animations\n\n// Chat open animations\n@keyframes quick {\n    0% {\n      opacity: 0;\n      transform: scale(0);\n      overflow: hidden;\n    }\n    90%, 50%{\n      overflow: hidden;\n    }\n    100% { \n        opacity: 1;\n        transform: scale(1);\n        overflow: inherit;\n    }\n}\n@keyframes bounce-in {\n    0% {\n      opacity: 0;\n      overflow: hidden;\n    }\n    40% {\n      opacity: 1;\n      overflow: hidden;\n    }\n    60% { \n      transform:translate(-10px)\n    }\n    80% { \n      transform:translate(-15px)\n    }\n    100% { \n      transform: none;\n      overflow: inherit;\n    }\n}\n\n// End\n\n// Bubble animations\n\n@keyframes bubbleAnim {\n    0% {\n      opacity: 0;\n      transform: translateY(10%);\n    }\n    20% {\n      opacity: 0;\n      transform: translateY(10%);\n    }\n    100% {\n      opacity: 1;\n      transform: translate(0%);\n    }\n}\n\n// End\n\n// Voice show animation\n\n@keyframes voiceShowAnim {\n  0% {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n  100% {\n    opacity: 1;\n    transform: translate(0%);\n  }\n}\n\n// Left to right template animations\n\n@keyframes left-to-right-slide-anim {\n    0% {\n      opacity: 0;\n      transform: translateX(-100%);\n    }\n    80% {\n        opacity: 0.5;\n        transform: translateX(0px);\n    }\n    100% {\n      opacity: 1;\n      transform: translate(0);\n    }\n}\n\n// End\n\n// Right to Left template animations\n\n@keyframes right-to-left-slide-anim {\n    0% {\n      opacity: 0;\n      transform: translateX(100%); /* Move the elements 100% down */\n    }\n    80% {\n        opacity: 0.5;\n        transform: translateX(10px); /* Move the elements to their original position */\n    }\n    100% {\n      opacity: 1;\n      transform: translate(0); /* Move the elements to their original position */\n    }\n}\n\n// Voice recording animations\n\n@keyframes recording {\n    from {\n        transform: scale( 1.1 );\n        box-shadow: 0 0 0 0 rgba(#4B4EDE, 0.2),\n          0 0 0 1px rgba(#4B4EDE, 0.2),\n          0 0 0 3px rgba(#4B4EDE, 0.2),\n          0 0 0 5px rgba(#4B4EDE, 0.2);\n    }\n\n    50% {\n        transform: none;\n    }\n\n    to {\n        transform: scale( 1.1 );\n        box-shadow: 0 0 0 0 rgba(#4B4EDE, 0.2),\n          0 0 0 3px rgba(#4B4EDE, 0.2),\n          0 0 0 6px rgba(#4B4EDE, 0),\n          0 0 0 10px rgba(#4B4EDE, 0);\n    }\n}\n\n@keyframes voiceAnim {\n    from {\n        transform: scale( 1.1 );\n    }\n    0% {\n        box-shadow: 0 0 0 0 rgba(#4B4EDE, 0.2),\n          0 0 0 1px rgba(#4B4EDE, 0.2),\n          0 0 0 3px rgba(#4B4EDE, 0.2),\n          0 0 0 5px rgba(#4B4EDE, 0.2);\n        // transform: scale(1.1);\n      }\n      50% {\n        transform: none;\n    }\n      100% {\n        box-shadow: 0 0 0 0 rgba(#4B4EDE, 0.2),\n          0 0 0 4px rgba(#4B4EDE, 0.2),\n          0 0 0 20px rgba(#4B4EDE, 0),\n          0 0 0 30px rgba(#4B4EDE, 0);\n        // transform: scale(0.9);\n        transform: scale( 1.1 );\n    }\n    to {\n        transform: scale( 1.1 );\n    }\n}\n\n// End\n\n// Bottom slider open close animations\n\n@keyframes closeBottomToTopAnim {\n    0% {\n      transform: translateY(0%);\n    }\n    100% {\n        opacity: 0;\n        transform: translateY(100%);\n        display: none;\n    }\n}   \n@keyframes slideBottomToTopAnim {\n    0% {\n      opacity: 0;\n      transform: translateY(100%);\n    }\n    80% {\n        opacity: 1;\n        transform: translateY(-10px);\n    }\n    100% {\n      opacity: 1;\n      transform: translate(0);\n    }\n}   \n\n// End\n\n\n// Zoom Animations\n\n.zoomIn {\n  -webkit-animation-name: zoomIn;\n  animation-name: zoomIn;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes zoomIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(.3, .3, .3);\n    transform: scale3d(.3, .3, .3);\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n@keyframes zoomIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(.3, .3, .3);\n    transform: scale3d(.3, .3, .3);\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n// End\n\n// Slide Animations\n\n.slideInRight {\n  -webkit-animation-name: slideInRight;\n  animation-name: slideInRight;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes slideInRight {\n  0% {\n    -webkit-transform: translateX(100%);\n    transform: translateX(100%);\n    visibility: visible;\n  }\n  80% {\n    -webkit-transform: translateX(0);\n    transform: translateX(2px);\n  }\n  100% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideInRight {\n  0% {\n    -webkit-transform: translateX(100%);\n    transform: translateX(100%);\n    visibility: visible;\n  }\n  80% {\n    -webkit-transform: translateX(0);\n    transform: translateX(2px);\n  }\n  100% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n}\n\n.scale-up-br {\n\t-webkit-animation: scale-up-br 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\n\t        animation: scale-up-br 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\n}\n\n.scale-out-br {\n\t-webkit-animation: scale-out-br 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;\n\t        animation: scale-out-br 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;\n}\n\n @-webkit-keyframes scale-out-br {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n    opacity: 1;\n  }\n}\n\n@keyframes scale-out-br {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n    opacity: 1;\n  }\n}\n\n\n@-webkit-keyframes scale-up-br {\n0% {\n  -webkit-transform: scale(0.5);\n          transform: scale(0.5);\n  -webkit-transform-origin: 100% 100%;\n          transform-origin: 100% 100%;\n}\n100% {\n  -webkit-transform: scale(1);\n          transform: scale(1);\n  -webkit-transform-origin: 100% 100%;\n          transform-origin: 100% 100%;\n}\n}\n\n@keyframes scale-up-br {\n  0% {\n    -webkit-transform: scale(0.5);\n            transform: scale(0.5);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n  }\n}\n\n\n/// Loader Animations\n\n@-webkit-keyframes spinLoader {\n  0% { -webkit-transform: rotate(0deg); }\n  100% { -webkit-transform: rotate(360deg); }\n}\n\n@keyframes spinLoader {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n\n// Rotate Icon close\n\n.rotateIn {\n  -webkit-animation-name: rotateIn;\n  animation-name: rotateIn;\n  -webkit-animation-duration: 0.5s;\n  animation-duration: 0.5s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes rotateIn {\n  0% {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transform: rotate3d(0, 0, 1, -200deg);\n    transform: rotate3d(0, 0, 1, -200deg);\n    opacity: 0;\n  }\n\n  100% {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transform: none;\n    transform: none;\n    opacity: 1;\n  }\n}\n\n@keyframes rotateIn {\n  0% {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transform: rotate3d(0, 0, 1, -200deg);\n    transform: rotate3d(0, 0, 1, -200deg);\n    opacity: 0;\n  }\n\n  100% {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transform: none;\n    transform: none;\n    opacity: 1;\n  }\n}\n\n\n// Typing Indicator\n  \n@keyframes dot-flashing {\n  0% {\n      background-color: var(--sdk-gloabl-bg-secondary);\n  }\n  50%, 100% {\n      opacity: 0.5;\n  }\n}\n\n// Fade In\n\n.fadeIn {\n  -webkit-animation-name: fadeIn;\n  animation-name: fadeIn;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  display: flex;\n}\n\n@-webkit-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n\n\n\n.bounceInUp {\n  -webkit-animation-name: bounceInUp;\n  animation-name: bounceInUp;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes bounceInUp {\n\n  0%,\n  60%,\n  75%,\n  90%,\n  100% {\n    -webkit-transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n    transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n  }\n\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 3000px, 0);\n    transform: translate3d(0, 3000px, 0);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, -20px, 0);\n    transform: translate3d(0, -20px, 0);\n  }\n\n  75% {\n    -webkit-transform: translate3d(0, 10px, 0);\n    transform: translate3d(0, 10px, 0);\n  }\n\n  90% {\n    -webkit-transform: translate3d(0, -5px, 0);\n    transform: translate3d(0, -5px, 0);\n  }\n\n  100% {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n@keyframes bounceInUp {\n\n  0%,\n  60%,\n  75%,\n  90%,\n  100% {\n    -webkit-transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n    transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n  }\n\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 3000px, 0);\n    transform: translate3d(0, 3000px, 0);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, -20px, 0);\n    transform: translate3d(0, -20px, 0);\n  }\n\n  75% {\n    -webkit-transform: translate3d(0, 10px, 0);\n    transform: translate3d(0, 10px, 0);\n  }\n\n  90% {\n    -webkit-transform: translate3d(0, -5px, 0);\n    transform: translate3d(0, -5px, 0);\n  }\n\n  100% {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n\n\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n\n\n.fadeInUp {\n  -webkit-animation-name: fadeInUp;\n  animation-name: fadeInUp;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeInUp {\n  0% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n\n\n.fadeOut {\n  -webkit-animation-name: fadeOut;\n  animation-name: fadeOut;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n.slideOutDown {\n    -webkit-animation-name: slideOutDown;\n    animation-name: slideOutDown;\n    -webkit-animation-duration: 1s;\n    animation-duration: 1s;\n    -webkit-animation-fill-mode: both;\n    animation-fill-mode: both;\n  }\n  @-webkit-keyframes slideOutDown {\n    0% {\n      -webkit-transform: translateY(-10%);\n      transform: translateY(-10%);\n    }\n    100% {\n      -webkit-transform: translateY(0);\n      transform: translateY(0);\n    }\n}","@import '../variables.scss';\n.chat-widget-body-wrapper{\n    flex: 1 1 auto;\n    background: var(--chat-widget-body-bg) no-repeat;\n    background-size: cover;\n    overflow: auto;\n    height: calc(100vh - 330px); // Need to remove\n    padding-bottom: 5px;\n    .prev-message-list {\n        display: none;\n    }\n}","@import \"./animations.scss\";\n\n// Media Breakpoins\n\n$media-tablet: 768px;\n$media-mobile: 600px;\n\n:root{\n\n    // Main 4 colors pallet\n    --sdk-gloabl-primary-color:var(--chat-sdk-branding--global-primary-color);     // #4B4EDE;\n    --sdk-gloabl-secondary-color:var(--chat-sdk-branding--global-secondary-color);    // #EAECF0;\n    --sdk-global-primary-text:var(--chat-sdk-branding--global-primary-text);     // #101828;\n    --sdk-global-secondary-text:var(--chat-sdk-branding--global-secondary-text);      // #FFFFFF;\n    // End\n\n    // Main 4 colors for Panle and Widgets\n        --theme-panel-wigdet-primary-bg-color:var(--sdk-gloabl-primary-color);  // #175cd3;\n        --theme-panel-wigdet-secondary-bg-color:var(--sdk-gloabl-secondary-color);   // #EAECF0;\n        --theme-panel-wigdet-primary-text-color:var(--sdk-global-primary-text);  // #101828;\n        --theme-panel-wigdet-secondary-text-color:var(--sdk-global-secondary-text) ;   // #667085;\n    \n        // Extra colors\n        --panel-wigdet-primary-bg-color:var(--theme-panel-wigdet-primary-bg-color);\n        --panel-wigdet-secondary-bg-color:var(--theme-panel-wigdet-secondary-bg-color);\n        --panel-wigdet-primary-text-color:var(--theme-panel-wigdet-primary-text-color);\n        --panel-wigdet-secondary-text-color:var(--theme-panel-wigdet-secondary-text-color);\n        \n        --panel-wigdet-border-color:var(--panel-wigdet-secondary-bg-color);\n        --panel-wigdet-white-bg-color:var(--chat-sdk-branding--widget_panel-colors-bg_color);           //   #fff;\n        --panel-wigdet-white-text-color:#fff;\n        --panel-wigdet-left-menu-bg:var(--chat-sdk-branding--widget_panel-colors-bg_color);\n        --panel-wigdet-left-menu-selected-bg:var(--chat-sdk-branding--widget_panel-colors-sel_bg_color);\n        --panel-wigdet-left-menu-font-clr:var(--chat-sdk-branding--widget_panel-colors-color);\n        --panel-wigdet-left-menu-selected-font-clr:var(--chat-sdk-branding--widget_panel-colors-sel_color);\n\n    // End\n\n\n    // Font Family\n        --global-font-family: var(--chat-sdk-branding--global-font-family);   // \"Inter\";\n    // End\n\n    --sdk-global-theme-color:var(--sdk-gloabl-primary-color);\n    --sdk-gloabl-bg-secondary:var(--sdk-gloabl-secondary-color);\n    --sdk-global-white:var(--sdk-global-secondary-text);\n    --sdk-global-white-bg:var(--chat-sdk-branding--body-white-background);\n    --sdk-gloabl-text-color:var(--sdk-global-primary-text);\n    --sdk-gloabl-text-desc-color:var(--sdk-global-primary-text);\n    --sdk-gloabl-border-color:var(--sdk-gloabl-secondary-color);\n    --sdk-scrollbar-bg:var(--sdk-gloabl-bg-secondary);\n\n    // Avatar Variables\n        --avatar-bg:var(--chat-sdk-branding--chat_bubble-bg-primary_color);  // var(--sdk-global-theme-color); \n        --avatar-send-msg-bg:var(--chat-sdk-branding--chat_bubble-bg-primary_color); // var(--sdk-global-theme-color);\n        --avatar-icon-color:var(--chat-sdk-branding--chat_bubble-bg-secondary_color);\n        --avatar-text-colr:var(--sdk-gloabl-text-color);\n    // End\n\n    //chat Widget Main\n        --chat-widget-box-shadow:0px 4px 12px 2px rgba(32, 33, 36, 0.12);\n    // End\n    \n    // Agent Joined Template\n        --agent-joined-bg:var(--sdk-gloabl-bg-secondary);\n        --agent-joined-border:var(--sdk-gloabl-border-color);\n        --agent-joined-text-color:var(--sdk-gloabl-text-color);\n    // End\n\n    // Welcome screen Variables\n        --welcome-bg:var(--sdk-global-white-bg); //#F8FAFC\n        --welcome-shadow:0px 4px 12px 2px rgba(32,33,36,0.12);\n        --welcome-header-bg: var(--chat-sdk-branding--welcome_screen-background-color);  // var(--sdk-global-theme-color);\n        --welcome-header-text-color:var(--chat-sdk-branding--welcome_screen-top_fonts-color);  // var(--sdk-global-white);\n        --welcome-start-conv-bg:var(--sdk-global-white-bg);\n        --welcome-start-conv-border:var(--sdk-gloabl-border-color);\n        --welcome-start-conv-bot-bg:var(--sdk-global-theme-color);\n        --welcome-start-conv-bot-title:var(--sdk-gloabl-text-color);\n        --welcome-start-conv-bot-desc:var(--sdk-gloabl-text-desc-color);\n        --welcome-start-conv-quick-btn-bg:var(--sdk-global-white-bg);\n        --welcome-start-conv-quick-btn-border:var(--sdk-gloabl-border-color);\n        --welcome-start-conv-quick-btn-text:var(--sdk-gloabl-text-color);\n        --welcome-start-conv-search-bg:var(--sdk-global-white-bg);\n        --welcome-start-conv-search-border:var(--sdk-gloabl-border-color);\n        --welcome-start-conv-button-bg:var(--chat-sdk-branding--welcome_screen-starter_box-start_conv_button_color); // var(--sdk-global-theme-color);\n        --welcome-start-conv-button-border:var(--sdk-global-theme-color);\n        --welcome-start-conv-button-color:var(--chat-sdk-branding--welcome_screen-starter_box-start_conv_text_color); //  var(--sdk-global-white);\n        --welcome-footer-bg:var(--chat-sdk-branding--welcome_screen-bottom_background-color);  // var(--sdk-global-theme-color);\n        --welecome-footer-text-color:var(--sdk-gloabl-text-color);\n    // End\n\n    // Chat Widget Header Variables;\n        --chat-widget-header-bg:var(--chat-sdk-branding--header-bg-bg_color);  // var(--sdk-global-white-bg);\n        --chat-widget-header-border:var(--sdk-gloabl-border-color);\n        --chat-widget-header-bg-large:linear-gradient(180deg, var(--sdk-global-theme-color) 0%, var(--sdk-global-theme-color) 40.67%, rgba(255, 255, 255, 0) 80.38%); // var(--sdk-global-theme-color)\n        --chat-widget-header-bg-large-info-bg:var(--sdk-global-white-bg);\n        --chat-widget-header-bg-large-actions-color:var(--sdk-global-white);\n        --chat-widget-header-bot-name-color:var(--chat-sdk-branding--header-title-color); // var(--sdk-gloabl-text-color);\n        --chat-widget-header-bot-name-desc:var(--chat-sdk-branding--header-sub_title-color); // var(--sdk-gloabl-text-color);\n        --chat-widget-header-actions-color:var(--chat-sdk-branding--header-icons-color);  // var(--sdk-gloabl-text-color);\n        --chat-widget-header-img-border:var(--sdk-global-white);\n    // End\n\n    // Chat Widget Body Variables;\n        --chat-widget-body-bg:var(--chat-sdk-branding--body-background-bg);  //  var(--sdk-global-white-bg);\n    // End\n\n    // Chat Widget Footer Variables;\n        --chat-widget-footer-bg: var(--sdk-global-white-bg);\n        --chat-widget-compose-bar-bg:var(--chat-sdk-branding--footer-bg-bg_color); // var(--sdk-gloabl-bg-secondary);\n        --chat-widget-compose-bar-border:var(--sdk-gloabl-border-color);\n        --chat-widget-compose-bar-text-area-bg:var(--chat-sdk-branding--footer-compose_bar-bg_color);  // var(--sdk-global-white-bg);\n        --chat-widget-compose-bar-text-area-border:var(--chat-sdk-branding--footer-compose_bar-outline-color); // var(--sdk-gloabl-border-color);\n        --chat-widget-compose-bar-text-area-color:var(--sdk-gloabl-text-color);\n        --chat-widget-compose-bar-text-area-placeholder-color:var(--sdk-gloabl-text-color);\n        --chat-widget-compose-bar-voice-speak-info-text:var(--sdk-gloabl-text-color);\n        --chat-widget-compose-bar-voice-icon-bg:var(--sdk-global-theme-color);\n        --chat-widget-compose-bar-voice-icon-border:var(--sdk-global-white-bg);\n        --chat-widget-compose-bar-voice-icon-color:var(--sdk-global-white);\n        --chat-widget-compose-bar-voice-speak-msg-bg:var(--sdk-global-white-bg);\n        --chat-widget-compose-bar-voice-speak-msg-selected-bg:var(--sdk-gloabl-bg-secondary);\n        --chat-widget-compose-bar-voice-speak-msg-color:var(--sdk-global-theme-color);\n        --chat-widget-compose-bar-voice-speak-msg-border:var(--sdk-global-theme-color);\n        --chat-widget-compose-bar-voice-recording-animation-shadow:0 0 0 0 rgba(var(--sdk-global-theme-color), 0.2), 0 0 0 1px rgba(var(--sdk-global-theme-color), 0.2), 0 0 0 3px rgba(var(--sdk-global-theme-color), 0.2), 0 0 0 5px rgba(var(--sdk-global-theme-color), 0.2);\n        --chat-widget-compose-bar-voice-recording-animation-shadow-zoom:0 0 0 0 rgba(var(--sdk-global-theme-color), 0.2),0 0 0 3px rgba(var(--sdk-global-theme-color), 0.2),0 0 0 6px rgba(var(--sdk-global-theme-color), 0),0 0 0 10px rgba(var(--sdk-global-theme-color), 0);\n        --chat-widget-compose-bar-menu-icon-color:var(--chat-sdk-branding--footer-menu_icon-color); // var(--sdk-gloabl-text-color);\n        --chat-widget-compose-bar-other-icons:var(--chat-sdk-branding--footer-icons-color); // var(--sdk-gloabl-text-color);\n    // End\n\n    // Bot Bubble Messages Variables\n        --bot-bubble-text-color:var(--sdk-gloabl-text-color);\n        --bot-bubble-msg-bg:var(--chat-sdk-branding--body-bot_message-bg_color);  // var(--sdk-gloabl-bg-secondary);\n        --bot-bubble-msg-bg-hover:var(--chat-sdk-branding--body-bot_message-bg_color);  // var(--sdk-gloabl-bg-secondary);\n        --bot-bubble-msg-color:var(--chat-sdk-branding--body-bot_message-color);  // var(--sdk-gloabl-text-color);\n        --bot-bubble-img-border:var(--sdk-global-white-bg);\n    //End   \n\n    // Name\n        --name-color:var(--chat-sdk-branding--body-agent_message-title_color); // var(--sdk-global-primary-text)\n    // End\n\n    // Time stamp\n        --time-stamp-color:var(--chat-sdk-branding--body-time_stamp-color);     // var(--sdk-global-primary-text)\n    //End\n\n    // Agent Bubble Messages Variables\n        --agent-bubble-text-color:var(--sdk-gloabl-text-color);\n        --agent-bubble-msg-bg:var(--chat-sdk-branding--body-user_message-bg_color);  // var(--sdk-global-theme-color);\n        --agent-bubble-msg-bg-hover:var(--chat-sdk-branding--body-user_message-bg_color);  // var(--sdk-global-theme-color);\n        --agent-bubble-msg-color:var(--chat-sdk-branding--body-user_message-color);  // var(--sdk-global-white);\n        --agent-bubble-img-border:var(--sdk-global-white-bg);\n        --agent-bubble-read-status-icon-color:#22C55E;\n    //End\n\n    // Date Seperator styles\n        --date-seperator-bg:var(--sdk-gloabl-bg-secondary);\n        --date-seperator-border:var(--sdk-gloabl-border-color);\n        --date-seperator-line-border:var(--sdk-gloabl-border-color);\n        --date-seperator-color:var(--sdk-gloabl-text-color);\n    // End\n\n    // Buttons\n        --button-bg-color: var(--chat-sdk-branding--body-buttons-bg_color);\n        --button-text-color: var(--chat-sdk-branding--body-buttons-color);\n    // End\n\n    // Template Styles\n\n        // Button Template\n        --button-temp-bg:var(--sdk-global-white-bg);\n        --button-temp-border:var(--sdk-gloabl-border-color);\n        --button-temp-color:var(--sdk-gloabl-text-color);\n        --button-temp-bg-hover:var(--sdk-gloabl-bg-secondary);\n        --button-temp-bg-variation-1:var(--sdk-gloabl-bg-secondary);\n        --button-temp-variation-1-border:transparent;\n        --button-temp-variation-1-color:var(--button-bg-color);   // --sdk-global-theme-color\n        --button-temp-bg-variation-1-hover:linear-gradient(0deg, rgba(75, 78, 222, 0.07) 0%, rgba(75, 78, 222, 0.07) 100%), var(--sdk-gloabl-bg-secondary);\n        --button-temp-bg-variation-2:var(--button-bg-color);   // --sdk-global-theme-color\n        --button-temp-variation-2-border:var(--button-bg-color);  // --sdk-global-theme-color\n        --button-temp-variation-2-color:var(--button-text-color);  // --sdk-global-white\n        --button-temp-bg-variation-2-hover:linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), var(--button-bg-color);  // --sdk-global-theme-color\n        // End\n\n        // Card Template\n        --card-main-wrapper-bg:var(--sdk-gloabl-bg-secondary);\n        --card-main-wrapper-border:var(--sdk-gloabl-border-color);\n        --card-heading-title:var(--sdk-gloabl-text-color);\n        --card-temp-border:var(--sdk-gloabl-border-color);\n        --card-temp-bg:var(--sdk-global-white-bg);\n        --card-temp-color:var(--sdk-gloabl-text-color);\n        --card-temp-h1-color:var(--sdk-gloabl-text-color);\n        --card-temp-p-color:var(--sdk-gloabl-text-color);   \n        --card-temp-view-more-bg:var(--sdk-global-white-bg);\n        --card-temp-view-more-color:var(--sdk-global-theme-color);\n        --card-temp-view-more-border:var(--sdk-global-theme-color);\n        --card-temp-border-divided-bg:var(--sdk-gloabl-border-color);\n        // End     \n\n        // Form Template\n        --form-temp-bg:var(--sdk-gloabl-bg-secondary);\n        --form-temp--text-color:var(--sdk-gloabl-text-color);\n        --form-temp-input-bg:var(--sdk-global-white-bg);\n        --form-temp-input-box-shadow:0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n        --form-temp-input-placeholder:var(--sdk-gloabl-text-color);\n        \n        // Table Template\n        --table-border:var(--sdk-gloabl-border-color);\n        --table-header-text-color:var(--sdk-gloabl-text-color);\n        --table-body-tr-bg:var(--sdk-gloabl-bg-secondary);\n        --table-desc-text-color:var(--sdk-gloabl-text-color);\n        // End\n\n        // Radio Template\n            --radio-desc-text-clr:var(--sdk-gloabl-text-color);\n            --radio-border:var(--sdk-gloabl-border-color);\n            --radio-bg:var(--sdk-global-white-bg);\n            --radio-checked-shadow:inset 0 0 0 6px var(--sdk-global-white-bg);\n        // End\n}   \n\n\n\n// STANDARD SIZES\n$font-s-5:0.3125rem;\n$font-s-6:0.375rem;\n$font-s-7:0.4375rem;\n$font-s-8:0.5rem;\n$font-s-9:0.5625rem;\n$font-s-10:0.625rem;\n$font-s-11:0.6875rem;\n$font-s-12:0.75rem;\n$font-s-13:0.8125rem;\n$font-s-14:0.875rem;\n$font-s-15:0.9375rem;\n$font-s-16:1rem;\n$font-s-17:1.0625rem;\n$font-s-18:1.125rem;\n$font-s-19:1.1875rem;\n$font-s-20:1.25rem;\n$font-s-21:1.3125rem;\n$font-s-22:1.375rem;\n$font-s-23:1.4375rem;\n$font-s-24:1.5rem;\n$font-s-25:1.5625rem;\n$font-s-26:1.625rem;\n$font-s-27:1.6875rem;\n$font-s-28:1.75rem;\n$font-s-29:1.8125rem;\n$font-s-30:1.875rem;\n$font-s-31:1.9375rem;\n$font-s-32:2rem;\n$font-s-33:2.0625rem;\n$font-s-40:2.5rem;\n\n// Button primary\n\n.kr-button-primary{\n    border-radius: 4px;\n    padding: 5px 16px;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 18px;\n    height: 30px;\n    width: 100%;\n    cursor: pointer;\n    text-align: center;\n    transition: 0.2s all ease;\n    background: var(--button-temp-bg-variation-2);\n    border: 1px solid var(--button-temp-variation-2-border);\n    color: var(--button-temp-variation-2-color);\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 100%;\n    &.lg{\n        padding: 10px 16px;\n        height: 40px;\n        font-size: 14px;\n    }\n    &:hover{\n        background: var(--button-temp-bg-variation-2-hover);\n    }\n    &:disabled{\n        opacity: 0.5;\n        pointer-events: none;\n    }\n}\n.kr-button-secondary{\n    width: 100%;\n    background: var(--button-temp-bg);\n    border: 1px solid var(--button-temp-border);\n    border-radius: 4px;\n    padding: 5px 16px;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 18px;\n    height: 30px;\n    color: var(--button-temp-color);\n    cursor: pointer;\n    text-align: center;\n    transition: 0.2s all ease;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 100%;\n    &.lg{\n        padding: 10px 16px;\n        height: 40px;\n        font-size: 14px;\n    }\n    &:hover{\n        background: var(--button-temp-bg-hover);\n    }\n}\n\n.kr-button-blue-light{\n    width: 100%;\n    background: var(--button-bg-color);\n    border: 1px solid var(--button-bg-color);\n    border-radius: 4px;\n    padding: 5px 16px;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 18px;\n    height: 30px;\n    color: var(--button-text-color);   // #2B75E4\n    cursor: pointer;\n    text-align: center;\n    transition: 0.2s all ease;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 100%;\n    svg{\n        path{\n            fill: var(--button-bg-color);  // #2B75E4\n        }\n    }\n    &.lg{\n        padding: 10px 16px;\n        height: 40px;\n        font-size: 14px;\n    }\n    &:hover{\n        background: var(--button-bg-color);\n    }\n}\n\n.kore-chat-window-main-section{\n    .chart-disp-val{\n        fill: var(--sdk-gloabl-text-color);\n        font-size: 12px;\n    }\n    .chart-axis-line{\n        stroke: var(--sdk-gloabl-text-color);\n    }\n    .legend-title{\n        fill: var(--sdk-gloabl-text-color);\n        font-size: 12px;\n    }\n    polyline{\n        stroke: var(--sdk-gloabl-text-color);\n    }\n    .mouse-per-line{\n        text{\n            fill: var(--sdk-gloabl-text-color);\n            font-size: 12px;\n        }\n    }\n    .legend-value{\n        fill: var(--sdk-gloabl-text-color);\n        font-size: 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
